import { render, staticRenderFns } from "./OnboardingBrand.vue?vue&type=template&id=67234d8a&"
import script from "./OnboardingBrand.vue?vue&type=script&lang=js&"
export * from "./OnboardingBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports